// extracted by mini-css-extract-plugin
export default {"layout__content":"Layout_layout__content__hOqv9"};